module.exports = __webpack_public_path__ + "img/floorplan-1.4dcf11b4.png";